
export const PERMISSION_APPROVE_DISBURSEMENT = 'Approve Disbursment';
export const PERMISSION_APPROVE_SETTLEMENT = 'Approve Disbursment';

